export const MAILCHIMP_U = "91424e686e0fd39bbbe65dd6d"
export const MAILCHIMP_ID = "b61f1ff979"
export const MAILCHIMP_POST_URL = `https://network.us3.list-manage.com/subscribe/post?u=${MAILCHIMP_U}&amp;id=${MAILCHIMP_ID}`
